<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-09-20 08:58:04
 * @LastEditTime : 2024-09-29 08:58:36
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\settlementTask.vue
-->
<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-05-11 13:48:12
 * @LastEditors: hexy
 * @LastEditTime: 2023-05-11 14:12:08
 * @Description: 结算任务
 * @FilePath: \ICPSxin\src\views\platform\ICPS\Wise\settlementTask.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="tabtop" style="width: 380px">
          <div v-for="(item, index) in typelist" :key="index" @click="choose(item.status)">
            <div :class="currenindex == item.status ? 'active' : 'text'">
              {{ item.value }}
            </div>
          </div>
        </div>
        <!-- <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </div>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
          </el-collapse-transition> -->
        <div v-show="showCardNav">
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">工程名称</span>
              <el-input v-model="tableParam.engineeringName" style="width: 200px" clearable placeholder="请输入"
                @keyup.enter.native="gettableData()" />
            </span>
            <el-button icon="el-icon-search" size="medium" class="bottom_all but1"
              @click="(tableParam.page = 1), gettableData()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
          </div>
        </div>
        <div class="hr"></div>
        <div class="card">
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
              :height="screenHeight - 400" stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <el-table-column align="center" label="工程编号" prop="engineeringCode"></el-table-column>
              <el-table-column align="center" label="工程名称" min-width="230" prop="engineeringName"></el-table-column>
              <el-table-column align="center" label="审核状态" prop="handleStatus">
                <template slot-scope="scope">
                  <span v-if="scope.row.handleStatus == 0">无</span>
                  <span v-if="scope.row.handleStatus == 1">待处理</span>
                  <span v-if="scope.row.handleStatus == 2">已处理</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.settlementStatus !=2 " type="success" :underline="false"
                    @click="toConfirm(scope.row)">确认结算单</el-link>
                  <el-link v-else type="primary" :underline="false" @click="toConfirm(scope.row)">查看</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage } from "@/api/wise/settlementTask.js";
import { getUserInfo } from "@/utils/auth.js";

export default {
  components: {},
  mixins: [mixin],
  data() {
    return {
      UserInfo: "",
      tableParamType: false,
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      pagesType: 0,
      mouthReportStatusList: [
        { name: "待确认", id: 0 },
        { name: "已确认", id: 1 },
      ],
      currenindex: 1,
      typelist: [
        {
          value: "供应中",
          status: 1,
        },
        {
          value: "完工未办",
          status: 2,
        },
      ],
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.tableParam = { ...this.tableParam, supplerStatus: 1, engineeringName: "" };
    this.init();
    this.gettableData();
  },

  methods: {
    choose(num) {
      this.currenindex = num;
      this.tableParam.supplerStatus = this.currenindex;
      this.gettableData();
    },
    init() {
      /*重置数据*/
      this.tableParam.engineeringName = "";
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    //   去确认
    toConfirm(row) {
      this.$router.push({ name: "settlementTaskSure", query: { row: JSON.stringify(row) } });
    },
  },
};
</script>
    
<style lang="scss" scoped>
.styleA {
  overflow: auto;
  max-height: calc(85vh - 266px);
  padding-right: 10px;
}

.styleB {
  overflow: auto;
  max-height: calc(85vh - 366px);
  padding-right: 10px;
}

.saledialoginfo {
  padding: 20px 20px 0 0px;
  max-height: calc(85vh - 220px);
}

.el-input,
.el-select {
  width: 240px;
}

.top_link {
  color: #008000;
}

.top_link:hover {
  cursor: pointer;
  opacity: 0.7;
}

.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

.tabtop {
  width: 378px;
  display: flex;
  border: $bg_color 1px solid;
  border-radius: 4px;
  margin: 20px 20px 0 20px;

  >div {
    height: 40px;
    width: 190px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;

    .text {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: $bg_color;
    }

    .active {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: $bg_color;
      border-radius: 4px;
    }

    .hr {
      height: 20px;
      width: 2px;
      background: $bg_color;
    }
  }
}

.el-input,
.el-select {
  width: 227px;
}

.dialoginfo {
  padding: 0;
}

.form-title {
  font-size: 18px;
  margin: 10px 0;
}</style>
    